export default __webpack_public_path__ + "static/media/usericon.20799d4f.jpg";